export default __webpack_public_path__ + "static/five-stars-f0b166709cc63074837d5f77bb87071d.png";